	import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BlobResponse } from '../../Models/OtherClasses';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class PTOEntitlementService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('PTOEntitlement');
	}
	
	loadAll(id: System.Guid) : Observable<ePM.Logic.PTOEntitlement[]> {
		return this.myBaseService.loadAll(this.url + '/Person/' + (id || ''));
	}
	flipreset(id: System.Guid): Observable<ePM.Logic.PTOEntitlement> {
		return this.myBaseService.post(null, this.url + '/Reset/' + (id || ''));
	}
	save(tempItem: ECI.Basic.ObjectBase) : Observable<ePM.Logic.PTOEntitlement> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.PTOEntitlement> {
		return this.myBaseService.getEdit(id, this.url);
	}
	entitlementReport(): Observable<BlobResponse> {
		return this.myBaseService.returnBlob(null, this.url + '/Download');
	}
}
